import { render, staticRenderFns } from "./DataFieldQueriesMenu.vue?vue&type=template&id=599e10dc&scoped=true"
import script from "./DataFieldQueriesMenu.vue?vue&type=script&lang=ts"
export * from "./DataFieldQueriesMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599e10dc",
  null
  
)

export default component.exports